module.exports = __webpack_public_path__ + "static/media/PWS.af5a4e23.png";